const choices: any = {
    '30 min': 0.5,
    '1 h': 1,
    '1h 30': 1.5,
    '2 h': 2,
    '2 h 30': 2.5,
    '3 h': 3,
    '3 h 30': 3.5,
    '4 h': 4,
    '4 h 30': 4.5,
    '5 h': 5,
    '5 h 30': 5.5,
    '6 h': 6
}

export const getIndicators = (submissions: any[]) => {
    let value = 0;

    submissions.forEach(submission => {
        let sum = 0;

        Object.keys(submission)
            .filter(question => question.endsWith('column_4'))
            .forEach(question => {
                const answer = submission[question] as string;
                if (choices.hasOwnProperty(answer)) {
                    sum += choices[answer];
                }
            });

        if (sum > 30) {
            value++;
        }
    })

    return value;
}